Ext.define('SA.view.menu.OpenDataFolder', {
    alias: 'widget.menu-open-data-folder',
    extend: 'Ext.menu.Item',

    text: 'Open Data Folder',

    handler() {
        SA.Sidebar.openDataFolder(this.attribute);
    }
});